import { Typography } from '@design-system/components/typography/typography';

import { ProgramConsumerTab } from '../../model/programs.types';

export const CONSUMER_TAB_TOOLTIP_COPY =
  'Programs in Subscription Offer will become automatically visible in Collections tab. Program in One Time purchase Offer will become automatically visible in Purchases tab.';

type ConsumerTabCellProps = {
  consumerTab: ProgramConsumerTab;
};

const toLabel = (consumerTab: ProgramConsumerTab): string => {
  if (consumerTab === 'collections') return 'Collections';
  if (consumerTab === 'purchases') return 'Purchases';
  return '-';
};

export const ConsumerTabCell = ({ consumerTab }: ConsumerTabCellProps) => {
  return (
    <Typography variant="body" size="small" fontWeight="normal">
      {toLabel(consumerTab)}
    </Typography>
  );
};
